import React from 'react';
import { defineMessages, t } from '@sm/intl';
import { MainNavButton } from '../nav-button';

const COPY = defineMessages({
  PLANS_AND_PRICING: {
    id: 'Pricing.plansAndPricing',
    defaultMessage: 'Plans & Pricing',
    description:
      '[Type: Label][Vis.: low] - Plans & Pricing section of nav bar',
  },
});

const Pricing = () => (
  <MainNavButton
    href="/pricing/upgrade/quickview/"
    label={t(COPY.PLANS_AND_PRICING)}
    navItem="plans and pricing"
  />
);

export default Pricing;
export { Pricing };
